import type { Account } from '@modules-deprecated/app/accounts/types'
import type { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { formatPaddedAccountNumber } from './formatPaddedAccountNumber'
import { getVatAccountNumberFromTaxRate } from './getVatAccountNumberFromTaxRate'

interface EnrichReviewEntryLineMetadataProps {
  accountId: string
  accountNumber?: string
  accounts: Account[]
  taxRates: TaxRate[]
  vatAccountNumber?: string | null
  vatRateId: string
}

export const enrichReviewEntryLineMetadata = ({
  accountId,
  accountNumber,
  accounts,
  taxRates,
  vatAccountNumber,
  vatRateId,
}: EnrichReviewEntryLineMetadataProps) => {
  const resolvedAccountNumber =
    accountNumber ||
    (accountId ? formatPaddedAccountNumber(accounts.find(({ id }) => id === accountId)?.accountNo) : '')

  const resolvedVatAccountNumber =
    vatAccountNumber ??
    getVatAccountNumberFromTaxRate(
      taxRates.find(({ id }) => id === vatRateId),
      accounts,
    )

  return {
    accountNumber: resolvedAccountNumber,
    vatAccountNumber: resolvedVatAccountNumber,
  }
}
